<template>
	<div class="c-brands-list">
		<div class="c-brands-list__limit">
			<p>
				{{ activeTrackers.length }} / {{ workspace.trackerLimit }} brands
				tracked. <router-link to="/profile/billing">Upgrade</router-link> to
				track more brands.
			</p>
			<div class="c-brands-list__limit__progress">
				<span :style="progressStyle"></span>
			</div>
		</div>
		<div>
			<div class="c-brands-list__header" v-if="computedBlocks.length !== 0">
				<span> </span>
				<span> Brand </span>
				<span> Tracked since </span>
				<span> Last updated </span>
				<span class="mediamix">
					<svg
						title="Video"
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M5 4H19M11 11.5V15.5L13.5 13.5L11 11.5ZM4 20H20C20.5523 20 21 19.5523 21 19V8C21 7.44772 20.5523 7 20 7H4C3.44772 7 3 7.44772 3 8V19C3 19.5523 3.44772 20 4 20Z"
							stroke="currentColor"
							stroke-width="2"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
					</svg>
					<svg
						title="Statics"
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							fill-rule="evenodd"
							clip-rule="evenodd"
							d="M3 4C3 3.44772 3.44772 3 4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4ZM5 5V13.5858L7.29289 11.2929C7.68342 10.9024 8.31658 10.9024 8.70711 11.2929L16.4142 19H19V5H5ZM13.5858 19L8 13.4142L5 16.4142V19H13.5858Z"
							fill="currentColor"
						/>
						<path
							d="M13.5745 8.35093L14.0528 7.39443C14.237 7.0259 14.763 7.0259 14.9472 7.39443L15.4255 8.35093C15.4738 8.44769 15.5523 8.52615 15.6491 8.57454L16.6056 9.05279C16.9741 9.23705 16.9741 9.76295 16.6056 9.94721L15.6491 10.4255C15.5523 10.4738 15.4738 10.5523 15.4255 10.6491L14.9472 11.6056C14.763 11.9741 14.237 11.9741 14.0528 11.6056L13.5745 10.6491C13.5262 10.5523 13.4477 10.4738 13.3509 10.4255L12.3944 9.94721C12.0259 9.76295 12.0259 9.23705 12.3944 9.05279L13.3509 8.57454C13.4477 8.52615 13.5262 8.44769 13.5745 8.35093Z"
							fill="currentColor"
						/>
					</svg>
					<svg
						title="Carousels"
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M7 18H4C3.44772 18 3 17.5523 3 17V7C3 6.44772 3.44772 6 4 6H7"
							stroke="currentColor"
							stroke-width="2"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
						<path
							d="M16 4H8C7.44772 4 7 4.44772 7 5V19C7 19.5523 7.44772 20 8 20H16C16.5523 20 17 19.5523 17 19V5C17 4.44772 16.5523 4 16 4Z"
							stroke="currentColor"
							stroke-width="2"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
						<path
							d="M17 6H20C20.5523 6 21 6.44772 21 7V17C21 17.5523 20.5523 18 20 18H17"
							stroke="currentColor"
							stroke-width="2"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
					</svg>
				</span>
				<span> Total ads </span>
				<span></span>
			</div>
			<router-link
				class="c-brands-list__item"
				v-for="block in computedBlocks"
				:key="block.id"
				:to="`/brands/${block.slug}`"
			>
				<span>
					<img :src="`${assetUrl}/${block.logo}`" />
				</span>
				<span>
					<strong>
						{{ block.name }}
					</strong>
				</span>
				<span>
					{{ formattedDate(block) }}
				</span>
				<span>
					{{ lastUpdated(block) }}
				</span>
				<span class="mediamix">
					<template v-if="block.insight">
						<p>
							{{ block.insight.lifetime.assetTypes.video }}
						</p>
						<p>
							{{ block.insight.lifetime.assetTypes.image }}
						</p>
						<p>
							{{ block.insight.lifetime.assetTypes.carousel }}
						</p>
					</template>
				</span>
				<span>
					{{ block.blockCount }}
				</span>
			</router-link>
		</div>
		<Empty v-if="computedBlocks.length === 0 && !processing" />
	</div>
</template>

<script>
import filter from '@swipekit/lib/filter';
import { getParams, setParams } from '@swipekit/lib/query-param-utils';

import api from '@swipekit/lib/api';

import Empty from './empty';

import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);

export default {
	components: {
		Empty,
	},

	data: function () {
		return {
			params: {
				query: '',
				network: 'all',
				mediaType: 'all',
				activeAds: 0,
				categories: [],
				brands: [],
			},
			blocks: [],
			skip: 0,
			take: 0,

			end: false,

			view: '',
		};
	},

	props: {},

	watch: {
		$route: function () {},
		refreshFilters: function () {
			this.filter();
		},
	},

	computed: {
		assetUrl: function () {
			return this.$store.getters['config/assetUrl'];
		},
		activeTrackers: function () {
			let tempBlocks = this.computedBlocks.filter((b) => {
				if (b.status === 'ACTIVE') {
					return true;
				}
				return false;
			});

			return tempBlocks;
		},
		progressStyle: function () {
			let width = 100;
			let trackerLimit = this.workspace.trackerLimit;

			let tempBlocks = this.activeTrackers;

			let diff = tempBlocks.length / trackerLimit;

			width = diff * 100;

			if (width >= 100) {
				width = 100;
			}

			let style = {
				width: `${width}%`,
			};

			if (width > 85) {
				style['background-color'] = `var(--color-danger)`;
			}

			return style;
		},
		workspace: function () {
			return this.$store.getters['workspaces/all'];
		},
		multiplayerCategories: function () {
			return this.$store.getters['app/multiplayerCategories'];
		},
		refreshFilters: function () {
			return this.$store.getters['app/refreshFilters'];
		},
		computedBlocks: function () {
			let blocks = this.blocks;

			return blocks;
		},
		processing: function () {
			return this.$store.getters['app/processing'];
		},
	},

	methods: {
		formattedDate: function (block) {
			let date = block.createdAt;

			if (!date) {
				return '';
			}

			let formattedDate = dayjs(date).fromNow();

			return formattedDate;
		},
		lastUpdated: function (block) {
			let lastCheckedAt = block.lastCheckedAt;

			if (!lastCheckedAt) {
				return;
			}

			let formattedDate = dayjs(lastCheckedAt).fromNow();

			return formattedDate;
		},
		async onView(view) {
			this.view = view;

			api.api.setOption('view', view);
		},
		onSubmit: function (e) {
			this.$emit('onSubmit', e);
		},
		applyParams: function (params) {
			if (params.query) {
				this.params.query = params.query;
			}

			if (params.skip) {
				this.skip = params.skip;
			}
			if (params.take) {
				this.take = params.take;
			}

			if (params.categories) {
				this.params.categories = params.categories;
			}

			if (params.brands) {
				this.params.brands = params.brands;
			}

			if (params.mediaType) {
				this.params.mediaType = params.mediaType;
			}

			if (params.activeAds) {
				this.params.activeAds = params.activeAds;
			}

			if (params.network) {
				this.params.network = params.network;
			}
		},
		onEnd: function () {
			if (this.processing) {
				return;
			}
			if (this.end) {
				return;
			}
			this.skip += this.take;
			this.filter();
		},
		async onSearch(params) {
			this.blocks = [];
			this.skip = 0;
			this.end = false;
			await this.filter(params);
		},
		async filter(params, firstTime = false) {
			if (this.processing) {
				// we don't need to wait for processing for this one, just sleep and try again in a few ms
				await new Promise((r) => setTimeout(r, 500));
			}
			this.$store.dispatch('app/setProcessing', true);

			if (firstTime) {
				params = getParams();

				// if first time, force 1st page
				params.skip = 0;

				this.applyParams(params);
			}
			if (!params) {
				params = getParams();
			}

			params.skip = this.skip;
			params.take = this.take;

			setParams(params);

			const blocks = await filter(params, 'filter-brands');

			if (blocks.length < this.take) {
				this.end = true;
			}
			this.blocks = this.blocks.concat(blocks);

			this.$nextTick(() => {
				this.$store.dispatch('app/setProcessing', false);
			});
		},
	},

	mounted: async function () {
		this.skip = 0;
		this.take = 40;
		this.filter(null, true);

		let options = await api.api.getOptions();

		this.view = options.view || 'all';
	},
};
</script>

<style lang="scss">
.c-brands-list {
	padding-top: var(--spacer);
	padding-bottom: var(--spacer);

	&__limit {
		position: relative;
		border-radius: var(--border-radius);
		background-color: var(--color-bg-3);
		padding: var(--margin-lg);
		max-width: 720px;
		margin: 0 auto;
		margin-bottom: var(--spacer);

		p {
			font-size: var(--font-size-xs);
			font-weight: 450;
			margin-bottom: 0.25rem;
		}

		&__progress {
			border-radius: 8px;
			width: 100%;
			height: 8px;
			background-color: var(--color-bg-5);
			overflow: hidden;

			display: flex;

			> span {
				display: inline-block;
				height: 100%;
				background-color: var(--color-warning);
				border-radius: var(--border-radius);
			}
		}
	}

	&__header {
		padding: var(--margin) var(--margin-lg);
		background-color: var(--color-bg-3);
		color: hsl(var(--p), 15%, 35%);
		border-radius: 4px;
		font-size: var(--font-size-sm);
		font-weight: 500;

		display: grid;
		grid-template-columns: 40px 1fr 150px 150px 150px 74px 24px;
		align-items: center;
		margin: 0 auto;
		position: relative;

		.mediamix {
			display: grid;
			grid-template-columns: 40px 40px 40px;
			align-items: center;
			justify-items: center;
		}
	}

	&__item {
		display: grid;
		grid-template-columns: 40px 1fr 150px 150px 150px 74px 24px;
		align-items: center;
		margin: 0 auto;
		position: relative;
		padding: var(--margin) var(--margin-lg);

		color: hsl(var(--p), 15%, 38%);
		font-size: var(--font-size-sm);

		&:hover,
		&:active,
		&:focus {
			background-color: var(--color-bg-3);
		}

		img {
			width: 24px;
			height: 24px;
			object-fit: cover;
			object-position: center center;
			border-radius: 99px;
		}

		&:not(:last-of-type) {
			border-bottom: var(--color-bg-3) solid 1px;
		}

		.mediamix {
			display: grid;
			grid-template-columns: 40px 40px 40px;
			align-items: center;
			text-align: center;
			font-size: var(--font-size-xs);
			font-feature-settings: 'case' 0, 'dlig' 0, 'frac' 0, 'dnom' 0, 'numr' 0,
				'subs' 0, 'sups' 0, 'tnum', 'zero' 0, 'ss01', 'ss02' 0, 'ss03' 0, 'ss04',
				'ss05' 0, 'ss06' 0, 'ss07' 0, 'ss08' 0, 'cv01' 0, 'cv02' 0, 'cv03' 0,
				'cv04' 0, 'cv05' 0, 'cv06' 0, 'cv07' 0, 'cv08' 0, 'cv09' 0, 'cv10' 0,
				'cv11' 0, 'cv12' 0, 'cv13' 0, 'cpsp' 0, 'c2sc' 0, 'salt' 0, 'aalt' 0,
				'calt', 'ccmp', 'locl', 'kern';
		}

		strong {
			font-weight: 500;
			color: var(--color-font);
		}

		p {
			margin-bottom: 0;
		}
	}
}
</style>
